{
    "upload_company_logo": "Allowed file types: any image.",
    "upload_profile_picture": "Allowed file types: any image."
}
